import axios from "axios";

const BASE = "https://us-central1-inprojuy-f1173.cloudfunctions.net/app";

export const adminApi = {
  // Roles
  getRoles: () => axios.get(`${BASE}/api/admin/roles`),
  crearRol: (data) => axios.post(`${BASE}/api/admin/roles`, data),
  editarRol: (id, data) => axios.put(`${BASE}/api/admin/roles/${id}`, data),
  eliminarRol: (id) => axios.delete(`${BASE}/api/admin/roles/${id}`),

  // Permisos
  getPermisosCatalogo: () => axios.get(`${BASE}/api/admin/permisos-catalogo`),

  // Usuarios
  getUsuarios: () => axios.get(`${BASE}/users`),
  cambiarRolUsuario: (userId, newRole) =>
    axios.post(`${BASE}/users/${userId}/role`, { newRole }),

  // Notificaciones
  getNotificaciones: () => axios.get(`${BASE}/api/admin/notificaciones-config`),
  actualizarNotificacion: (tipo, destinatarios) =>
    axios.put(`${BASE}/api/admin/notificaciones-config/${tipo}`, { destinatarios }),

  // Audit log
  getAuditLog: (limit = 50, startAfter) =>
    axios.get(`${BASE}/api/admin/audit-log`, { params: { limit, startAfter } }),
};
